// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Hg79","productName":"Table_productName__3esym"};